import { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit, Preview } from '@mui/icons-material';
import CategoryDeleteDialog from './CategoryDeleteDialog';
import { useNavigate } from 'react-router-dom';
// import { useValue } from '../../../context/ContextProvider';
// import { deleteRoom } from '../../../actions/room';

const CategoryActions = ({ params }) => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  //   const {
  //     dispatch,
  //     state: { currentUser },
  //   } = useValue();
  return (
    <>
      <Box>
        <Tooltip title="View category details">
          <IconButton
            onClick={() => alert('Preview')}
            //   onClick={() => dispatch({ type: 'UPDATE_ROOM', payload: params.row })}
          >
            <Preview />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edit this category">
          <IconButton onClick={() => navigate(`/categories/${params.id}/edit`)}>
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete this category">
          <IconButton
            onClick={handleOpen}
            //   onClick={() => deleteRoom(params.row, currentUser, dispatch)}
          >
            <Delete />
          </IconButton>
        </Tooltip>
      </Box>
      {open && (
        <CategoryDeleteDialog
          cat={params}
          open={open}
          onHandleClose={handleClose}
        />
      )}
    </>
  );
};

export default CategoryActions;
